const childKey = (child = {}) =>
  `${child.firstName?.trim().toLowerCase()}_${child.lastName?.trim().toLowerCase()}_${child.dateBirth}`;

export const getUnmatchedChildren = (targetChildren = [], sourceChildren = []) => {
  const targetKeys = new Set(targetChildren.map(childKey));
  return sourceChildren.filter((child) => !targetKeys.has(childKey(child)));
};

export const childrenFromFamilies = (families = []) => {
  const children = families.flatMap((family) => family?.children || []);
  return Array.from(
    new Map(children.filter(Boolean).map((child) => [child.id || childKey(child), child])).values()
  );
};

